import { render, staticRenderFns } from "./CamView.vue?vue&type=template&id=56d45528"
import script from "./CamView.vue?vue&type=script&lang=ts"
export * from "./CamView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports